import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Branded intro shown right before the login screen (logged-out path only).
// Pure CSS/Framer Motion — no video, loads instantly. Auto-dismisses via onDone.
export default function LoginIntro({ onDone }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const tFade = setTimeout(() => setExiting(true), 1700); // entrance (350) + hold (1350)
    const tDone = setTimeout(() => onDone && onDone(), 1900); // + fade (200), total ~1.9s
    return () => { clearTimeout(tFade); clearTimeout(tDone); };
  }, [onDone]);

  return (
    <AnimatePresence>
      {!exiting && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.2, ease: 'easeIn' } }}
          data-testid="login-intro"
        >
          {/* Brand colour wash */}
          <div className="absolute inset-0" style={{ background: 'linear-gradient(160deg,#EFF6FF 0%,#ECFDF5 100%)' }} />
          {/* Village illustration, dimmed to ~40% so it reads as a soft wash */}
          <div
            className="absolute inset-0 md:hidden"
            style={{ backgroundImage: "url('/login-bg-mobile.png')", backgroundSize: 'cover', backgroundPosition: 'center top', backgroundRepeat: 'no-repeat', opacity: 0.4 }}
          />
          <div
            className="absolute inset-0 hidden md:block"
            style={{ backgroundImage: "url('/login-bg-desktop.webp')", backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', opacity: 0.4 }}
          />

          {/* Soft white radial glow behind the logo — fades in, peaking ~550ms */}
          <motion.div
            className="absolute w-[520px] h-[520px] max-w-[90vw] max-h-[90vw] rounded-full pointer-events-none"
            style={{ background: 'radial-gradient(circle, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.55) 35%, rgba(255,255,255,0) 70%)' }}
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: [0, 0.95, 0.8], scale: [0.6, 1, 1] }}
            transition={{ duration: 0.55, ease: 'easeOut', times: [0, 0.75, 1] }}
          />

          {/* Logo: 85% -> 100% scale, 0 -> 100% opacity over 350ms ease-out */}
          <motion.div
            className="relative z-10 flex flex-col items-center"
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.35, ease: 'easeOut' }}
          >
            <div className="w-28 h-28 md:w-32 md:h-32">
              <img
                src="/logo-new.png"
                alt="GuestCheckout"
                className="w-full h-full object-contain drop-shadow-[0_10px_28px_rgba(15,23,42,0.28)]"
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
